<template>
  <v-btn @click="createCustomerModal" color="primary" elevation="0">
    <v-icon left>mdi-plus</v-icon>
    <span class="d-none d-md-flex body-2">
      {{ $t(`create.label.customer`) }}
    </span>
  </v-btn>
</template>

<script>
export default {
  name: 'CustomerHeaderActions',

  methods: {
    createCustomerModal() {
      const customerListComponent = this.$parent?.$parent?.$refs.usersRouterView
      customerListComponent?.openCreateCustomerModal()
    }
  }
}
</script>
